var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 3.75H9.75V14.25H8.25V3.75ZM3.75 9C4.575 9 5.25 8.325 5.25 7.5C5.25 6.675 4.575 6 3.75 6C2.925 6 2.25 6.675 2.25 7.5C2.25 8.325 2.925 9 3.75 9ZM5.835 10.185C5.1975 9.9075 4.4925 9.75 3.75 9.75C3.0075 9.75 2.3025 9.9075 1.665 10.185C1.11 10.425 0.75 10.965 0.75 11.5725V12H6.75V11.5725C6.75 10.965 6.39 10.425 5.835 10.185ZM14.25 9C15.075 9 15.75 8.325 15.75 7.5C15.75 6.675 15.075 6 14.25 6C13.425 6 12.75 6.675 12.75 7.5C12.75 8.325 13.425 9 14.25 9ZM16.335 10.185C15.6975 9.9075 14.9925 9.75 14.25 9.75C13.5075 9.75 12.8025 9.9075 12.165 10.185C11.61 10.425 11.25 10.965 11.25 11.5725V12H17.25V11.5725C17.25 10.965 16.89 10.425 16.335 10.185Z",
    fill: "inherit"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.9ddb922df8a476eeff064e1abdfceeb3.svg";
export { ForwardRef as ReactComponent };